import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notLoggedContainer: {
      width: "100%",
      display: "flex",
      borderRadius: 16,
      lineHeight: 1,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        boxShadow: "none",
        borderRadius: "0",
      },
    },
    leftPanel: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      flex: "1 0 40%",
      maxWidth: "575px",
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      alignItems: "left",
      paddingTop: theme.spacing(8),
      paddingLeft: theme.spacing(8),
      gap: theme.spacing(4),
      position: "relative",
      [theme.breakpoints.down("xs")]: {
        flex: "auto",
      },
    },
    rightPanel: {
      backgroundColor: "#fff",
      display: "flex",
      flex: "1 0 60%",
      flexDirection: "column",
      padding: theme.spacing(10, 8),
      position: "relative",
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(4),
        flex: "0 1 100%",
      },
    },
  })
);

export const LeftPanel = (props: { children: React.ReactNode }) => {
  const classes = useStyles();
  return (
    <Box className={classes.leftPanel} boxShadow={5}>
      {props.children}
    </Box>
  );
};

export const RightPanel = (props: { children: React.ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.rightPanel}>{props.children}</div>;
};

export const MainContainer = (props: { children: React.ReactNode }) => {
  const classes = useStyles();
  return (
    <Box className={classes.notLoggedContainer} boxShadow={5}>
      {props.children}
    </Box>
  );
};
